export default __webpack_public_path__ + "static/media/resource-unavailable-guy.f534d0fe.png";